export default __webpack_public_path__ + "static/media/aviso.576af5e0.svg";